import { StarFilled, StarTwoTone } from '@ant-design/icons';

import { contradictionColors } from '../../Constants/commonConstants';
import ShowMoreText from '../ShowMoreText';

function ComparisonCard({ fullData, files, handleBookmark }) {
  const filesIndexMapping = files.reduce((acc, f, i) => ({ ...acc, [f.file_name]: i }), {});

  return (
    <div className={`comparison-card`} id={fullData.id}>
      {fullData?.type === 'comparison' && (
        <div>
          <div
            style={{
              display: 'flex',
            }}
          >
            <div
              className='card-tags'
              style={{
                color: '#4EA6F8',
                background: '#E3F1FF',
              }}
            >
              Compare Across: All Documents
            </div>
          </div>
          <div className='card-heading'>
            <div>{fullData?.['Aspect/Clause/Topic']}</div>
            <div
              className='card-bookmark-action'
              onClick={() => {
                handleBookmark(fullData?.['Aspect/Clause/Topic'], !fullData?.shortlist);
              }}
            >
              {fullData?.shortlist ? (
                <StarFilled
                  style={{
                    color: '#0066FF',
                  }}
                />
              ) : (
                <StarTwoTone />
              )}
            </div>
          </div>

          <article>
            <div className='text-heading'>Summary of difference</div>

            <div className='text'>
              <ShowMoreText text={fullData?.['Summary of Difference']} maxLength={127} />
            </div>
          </article>
          {files?.map((f, i) => {
            return (
              // .pdf_url might get removed in future. Ask backend if providing an id is possible
              <article key={`file-${fullData?.id}-${f.pdf_url}`}>
                <div className='text-heading'>{f.file_name}</div>

                <div className='text'>
                  <ShowMoreText
                    text={
                      fullData?.[`${f?.file_name} Details`]?.text ||
                      fullData?.[`Document ${i + 1} Details`]?.text ||
                      ''
                    }
                    reference={
                      fullData?.[`${f?.file_name} Details`]?.reference ||
                      fullData?.[`Document ${i + 1} Details`]?.reference ||
                      ''
                    }
                    maxLength={127}
                  />
                </div>
              </article>
            );
          })}
        </div>
      )}
      {fullData?.type === 'contradiction' && (
        <div>
          <div
            style={{
              display: 'flex',
            }}
          >
            <div
              className='card-tags'
              style={{
                color: contradictionColors[filesIndexMapping[fullData?.sourceDoc]]?.textColor,
                background:
                  contradictionColors[filesIndexMapping[fullData?.sourceDoc]]?.backgroundColor,
              }}
            >
              Internal Contradictions: {fullData?.sourceDoc}
            </div>
          </div>
          <div className='card-heading'>{fullData?.['Aspect/Topic of Contradiction']}</div>

          <article>
            <div className='text-heading'>Nature of Contradiction</div>

            <div className='text'>
              <ShowMoreText text={fullData?.['Nature of Contradiction']} maxLength={127} />
            </div>
          </article>

          <article>
            <div className='text-heading'>Conflict Point 1</div>

            <div className='text'>
              <ShowMoreText
                text={fullData?.['Conflicting Point 1']?.text}
                reference={fullData?.['Conflicting Point 1']?.reference || ''}
                maxLength={127}
              />
            </div>
          </article>
          <article>
            <div className='text-heading'>Conflict Point 2</div>

            <div className='text'>
              <ShowMoreText
                text={fullData?.['Conflicting Point 2']?.text}
                reference={fullData?.['Conflicting Point 2']?.reference || ''}
                maxLength={127}
              />
            </div>
          </article>
          {fullData?.['Ref'] && (
            <article>
              <div className='text-heading'>Reference</div>

              <div className='text'>
                <ShowMoreText text={fullData?.['Ref']} maxLength={127} />
              </div>
            </article>
          )}
        </div>
      )}
    </div>
  );
}

export default ComparisonCard;
